<template>
  <div class="dft-container" :style="container_Style">
    <div class="dft-banner_box" :style="banner_box_Style">
      <div class="dft-banner_bg" :style="banner_bg_style">
        <div class="dft-banner_bg1" :style="banner_bg1_style">
        </div>
        <div class="dft-banner_bg2" :style="banner_bg2_style">
        </div>
      </div>
      <div class="dft-banner_info_box" :style="banner_info_style">
        <div class="dft-banner_area" :style="banner_area_style">
          <div class="dft-banner_logo" :style="banner_logo_style">
            <!-- uniapp -->
            <el-image class="img_class" :src="dft_banner_bg" :fit="fit"></el-image>
          </div>
          <div class="dft-banner_iarea" :style="banner_iarea_style">
            <div class="dft-banner_name" :style="banner_name_style">{{ '店铺名' }}</div>
            <div class="dft-banner_cnt" :style="banner_cnt_style">
              <div class="dft-banner_event">{{ '店铺活动' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
        type: [Array,Object],
        default: ()=>[]
    },
  },
  options: {
    styleIsolation: 'shared', // 解除样式隔离
  },
  data () {
    return {
      showDialog: false,
      dft_banner_bg: require('@/assets/images/icon_img/shop_banner.jpg'),
    };
  },
  watch:{
    compData: {
      handler: function(newVal){
        if(newVal){
          this.$nextTick(() => {
            // console.log('comp--D-ata',newVal)
          });
        }
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    //数据
    bannerImg(){
      return {
        'background-image': this.compData?.attr?.a1.value || this.dft_banner_bg
      }
    },
    styleClass(){
      return this.compData?.attr?.a2.value
    },
    logobg(){
      return this.compData?.attr?.a3.value == '1'
    },
    fit() {
      return 'contain' //? 'aspectFit' : 'widthFix'
    },
    // 样式
    container_Style(){
      switch (this.styleClass) {
        case '1':
        case '3':
          return{
            'height': `${185}px`,
          }
        case '2':
          return{
            'height': `${238}px`,
          }
        case '4':
          return{
            'height': `${258}px`,
          }
        case '5':
          return{
            'height': `${250}px`,
          }
        default:
          return {
          }
      }
    },
    banner_box_Style(){
      return {
        // [this.compData?.attr?.['a3']?.key]: this.compData?.attr?.['a3']?.value == '1' ? '': `${this.compData?.attr?.a5.value / 2}px`,
        // 'justify-content': this.compData?.attr?.['a4']?.value == 'left'?'flex-start':'center',
        // [this.compData?.attr?.['a8']?.key]: this.compData?.attr?.['a8']?.value,
        // [this.compData?.attr?.['a9']?.key]: this.compData?.attr?.['a9']?.value,
      }
    },
    banner_bg_style(){
      switch (this.styleClass) {
        case '2':
          return{
            'height': `${185}px`,
          }
        case '4':
          return{
            'height': `${150}px`,
          }
        default:
          return {
          }
      }
    },
    banner_bg1_style(){
      return {
        // 'padding-right': this.scan?'60px':'0',
        'background-image': `url(${this.compData?.attr?.a1.value || this.dft_banner_bg})`
      }
    },
    banner_bg2_style(){
      switch (this.styleClass) {
        case '2':
        case '3':
        case '4':
          return{
            'background-color': 'initial',
            'background-image': 'linear-gradient(0deg, #000, transparent)',
          }
        default:
          return {}
      }
    },
    banner_info_style(){
      switch (this.styleClass) {
        case '2':
          return{
            'top': `${150}px`,
          }
        case '5':
          return{
            'top': `${50}px`,
          }
        default:
          return {
          }
      }
    },
    banner_area_style(){
      switch (this.styleClass) {
        case '4':
        case '5':
          return{
            'height': `auto`,
            'flex-direction': `column`,
            'align-items': `center`,
          }
        default:
          return {
          }
      }
    },
    banner_logo_style(){
      switch (this.styleClass) {
        case '2':
        case '4':
          return{
            'width': `${70}px`,
            'height': `${70}px`,
            'border-radius': `50%`,
            'background-color': this.logobg?'#fff':'unset',
            'border': this.logobg?'1px solid #fff':'unset',
          }
        case '5':
          return{
            'border-radius': `50%`,
            'background-color': this.logobg?'#fff':'unset',
            'border': this.logobg?'1px solid #fff':'unset',
          }
        default:
          return {
          }
      }
    },
    banner_iarea_style(){
      switch (this.styleClass) {
        case '4':
        case '5':
          return{
            'padding': `0`,
            'text-align': `center`,
          }
        default:
          return {
          }
      }
    },
    banner_name_style(){
      switch (this.styleClass) {
        case '4':
          return{
            'display': 'inline-block',
            'max-width': '100%',
            'margin-top': '20px',
            'color': '#333',
            'text-shadow': 'none',
          }
        case '5':
          return{
            'display': 'inline-block',
            'max-width': '100%',
            'margin-top': '20px',
            'color': '#fff',
            'text-shadow': 'none',
            'padding-bottom': '10px',
            'border-bottom': '1px solid #ffffff80',
          }
        default:
          return {
          }
      }
    },
    banner_cnt_style(){
      switch (this.styleClass) {
        case '2':
        case '4':
          return{
            'color': `#989898`,
          }
        default:
          return {
          }
      }
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData(){
    },
  },
};
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  padding: 0;
  background-color: #fff;
}
.dft-banner_box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-size: 14px;
  position: relative;
}
.dft-banner_bg{
  width: 100%;
  height: 100%;
  position: relative;
  .dft-banner_bg1{
    width: 100%;
    height: 100%;
    // background-image
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    overflow: hidden;
  }
  .dft-banner_bg2{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .3);
  }
}
.dft-banner_info_box{
  position: absolute;
  width: 100%;
  top: 110px;
  // background: #fd2e08;
  // color: #fff;
  // width: 60px;
  // height: calc(100% - 6px);
  // margin: 0 3px;
  // padding: 4px 6px;
  // box-sizing: border-box;
  // text-align: center;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  .dft-banner_area{
    position: relative;
    width: 100%;
    height: 100%;
    height: 60px;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
  }
}
.dft-banner_logo{
  width: 60px;
  height: 60px;
  overflow: hidden;
  vertical-align: bottom;
  background: #fff;
}
.dft-banner_iarea{
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  padding-left: 10px;
  box-sizing: border-box;
}
.dft-banner_cnt{
  margin-top: 12px;
}
.dft-banner_name{
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-shadow: 0 1px 15px rgba(0, 0, 0, .5);
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
}
</style>

